
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/fyrirtaekid/reikningar-og-greidsluskilmalar",
      function () {
        return require("private-next-pages/um/fyrirtaekid/reikningar-og-greidsluskilmalar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/fyrirtaekid/reikningar-og-greidsluskilmalar"])
      });
    }
  